module.exports = (__webpack_require__("xqNg"))(1);


//////////////////
// WEBPACK FOOTER
// delegated ./src/plugins/jquery.js from dll-reference vendor_ccef94b5eabb04440e1a
// module id = mkhh
// module chunks = 2 3 4 5 6 7 8 9